export const comics = [
  {
    id: 1,
    title: '斗罗大陆',
    author: '唐家三少',
    category: '玄幻',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20illustration%20of%20young%20warrior%20in%20ancient%20fantasy%20setting%2C%20martial%20arts%20theme%2C%20warm%20golden%20lighting%2C%20clean%20manga%20cover%20design%2C%20professional%20digital%20art%2C%20soft%20beige%20background%20with%20subtle%20energy%20effects&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    description: '唐门外门弟子唐三，因偷学内门绝学为唐门所不容，跳崖明志时却来到另一个世界——斗罗大陆。',
    chapters: 356,
    rating: 9.6,
    views: '2.3亿',
    status: '连载中',
    isHot: true,
    isRecommended: true,
    updatedAt: '2026-07-06',
  },
  {
    id: 2,
    title: '一人之下',
    author: '米二',
    category: '热血',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20modern%20supernatural%20manhua%20cover%20style%2C%20young%20protagonist%20with%20mysterious%20powers%20in%20urban%20setting%2C%20action%20pose%2C%20vibrant%20warm%20colors%2C%20professional%20manga%20cover%20art%2C%20clean%20cream%20background&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    description: '随着爷爷尸体被盗，神秘少女冯宝宝的造访，少年张楚岚的平静校园生活被彻底颠覆。',
    chapters: 600,
    rating: 9.5,
    views: '1.8亿',
    status: '连载中',
    isHot: true,
    isRecommended: false,
    updatedAt: '2026-07-05',
  },
  {
    id: 3,
    title: '狐妖小红娘',
    author: '小新',
    category: '恋爱',
    cover: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20romance%20manhua%20cover%2C%20fox%20spirit%20girl%20with%20flowing%20red%20dress%20in%20ancient%20Chinese%20setting%2C%20cherry%20blossom%20petals%2C%20soft%20warm%20lighting%2C%20elegant%20manga%20art%2C%20clean%20light%20background&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    description: '世上有人有妖，妖会与人相恋，妖寿命千万年，人寿命有限。于是狐妖红娘就为前世恋人牵线续缘。',
    chapters: 480,
    rating: 9.4,
    views: '1.5亿',
    status: '连载中',
    isHot: false,
    isRecommended: true,
    updatedAt: '2026-07-06',
  },
  {
    id: 4,
    title: '镇魂街',
    author: '许辰',
    category: '热血',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20action%20manhua%20cover%20with%20armored%20warrior%20and%20guardian%20spirit%20in%20fantasy%20battlefield%2C%20dramatic%20lighting%2C%20warm%20amber%20tones%2C%20professional%20manga%20art%2C%20clean%20minimal%20background&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    description: '应届大学毕业生夏铃在求职之际，收到了一条奇怪的面试通知，误入罗刹街并改变了命运。',
    chapters: 420,
    rating: 9.3,
    views: '1.2亿',
    status: '连载中',
    isHot: false,
    isRecommended: true,
    updatedAt: '2026-07-04',
  },
  {
    id: 5,
    title: '全职高手',
    author: '蝴蝶蓝',
    category: '竞技',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20esports%20gaming%20manhua%20cover%2C%20cool%20male%20gamer%20protagonist%20with%20headset%2C%20cyberpunk%20aesthetic%2C%20warm%20golden%20accents%2C%20professional%20digital%20manga%20art%2C%20clean%20light%20background&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    description: '网游荣耀中被誉为教科书级别的顶尖高手叶修，因为种种原因遭到俱乐部的驱逐。',
    chapters: 280,
    rating: 9.2,
    views: '9800万',
    status: '已完结',
    isHot: true,
    isRecommended: false,
    updatedAt: '2026-06-20',
  },
  {
    id: 6,
    title: '镖人',
    author: '许先哲',
    category: '武侠',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20manhua%20cover%20with%20lone%20swordsman%20in%20desert%20wasteland%2C%20rough%20ink%20brush%20style%2C%20warm%20sepia%20tones%2C%20professional%20manga%20art%2C%20clean%20parchment%20background&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    description: '大业三年，隋王朝在隋炀帝杨广的残暴统治下民不聊生。身手不凡的镖客刀马行走于西域大漠。',
    chapters: 110,
    rating: 9.7,
    views: '8500万',
    status: '连载中',
    isHot: false,
    isRecommended: true,
    updatedAt: '2026-06-30',
  },
  {
    id: 7,
    title: '星海镖师',
    author: '颜开',
    category: '科幻',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20manhua%20cover%20with%20space%20bounty%20hunter%20in%20futuristic%20armor%2C%20nebula%20background%2C%20warm%20coral%20accents%2C%20professional%20manga%20art%20style%2C%20clean%20light%20background&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    description: '在遥远的未来，星际航行已是家常便饭。镖师们的使命就是在各个星域之间运送重要货物。',
    chapters: 350,
    rating: 9.1,
    views: '7200万',
    status: '连载中',
    isHot: false,
    isRecommended: false,
    updatedAt: '2026-07-03',
  },
  {
    id: 8,
    title: '秦时明月',
    author: '温世仁',
    category: '历史',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20manhua%20cover%20with%20ancient%20warriors%20in%20Qin%20dynasty%20setting%2C%20swordsman%20silhouette%20against%20moon%2C%20warm%20amber%20lighting%2C%20professional%20manga%20art%2C%20clean%20parchment%20background&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    description: '天下虽定，乱世未绝。天下第一剑客盖聂携故人之子荆天明，为躲避秦兵追杀，踏上了荆棘之路。',
    chapters: 230,
    rating: 9.5,
    views: '1.1亿',
    status: '连载中',
    isHot: false,
    isRecommended: true,
    updatedAt: '2026-07-01',
  },
  {
    id: 9,
    title: '妖怪名单',
    author: '糖人家',
    category: '奇幻',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20supernatural%20manhua%20cover%20with%20mysterious%20girl%20and%20magical%20creatures%2C%20fantasy%20urban%20setting%2C%20warm%20pinkish%20lighting%2C%20professional%20manga%20art%2C%20clean%20soft%20background&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    description: '大学生封夕与室友们一起住在一栋诡异的宿舍楼里，楼里住着各种妖怪和神仙的转世。',
    chapters: 390,
    rating: 9.0,
    views: '6500万',
    status: '连载中',
    isHot: false,
    isRecommended: false,
    updatedAt: '2026-07-02',
  },
  {
    id: 10,
    title: '西行纪',
    author: '郑健和',
    category: '玄幻',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20manhua%20cover%20with%20monkey%20king%20reimagined%20in%20dark%20epic%20style%2C%20journey%20to%20the%20west%20theme%2C%20warm%20dramatic%20lighting%2C%20professional%20manga%20art%2C%20clean%20background&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    description: '这是唐三藏师徒四人取得真经交予天庭的十六年后，世界却并没有因此变好。',
    chapters: 180,
    rating: 9.4,
    views: '9000万',
    status: '已完结',
    isHot: true,
    isRecommended: false,
    updatedAt: '2026-05-15',
  },
  {
    id: 11,
    title: '魔道祖师',
    author: '墨香铜臭',
    category: '古风',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20cultivation%20manhua%20cover%20with%20elegant%20male%20cultivator%20in%20flowing%20white%20robes%2C%20ancient%20Chinese%20aesthetic%2C%20soft%20warm%20lighting%2C%20professional%20manga%20art%2C%20clean%20light%20background&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    description: '前世的魏无羡万人唾骂，声名狼藉。被护持一生的师弟带人端了老巢，纵横一世，死无全尸。',
    chapters: 260,
    rating: 9.6,
    views: '1.6亿',
    status: '已完结',
    isHot: true,
    isRecommended: true,
    updatedAt: '2026-04-20',
  },
  {
    id: 12,
    title: '百炼成神',
    author: '恩赐解脱',
    category: '玄幻',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20cultivation%20manhua%20cover%20with%20young%20warrior%20training%20in%20mountain%20temple%2C%20martial%20arts%20theme%2C%20warm%20golden%20sunlight%2C%20professional%20manga%20art%2C%20clean%20background&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    description: '罗家的养子罗征，从小备受欺凌。直到有一天，他在一本古书中发现了惊天秘密。',
    chapters: 520,
    rating: 9.3,
    views: '1.4亿',
    status: '连载中',
    isHot: true,
    isRecommended: false,
    updatedAt: '2026-07-07',
  },
];